function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { useMemo, useRef, useState } from "react";
import { CAROUSEL_PROPS } from "segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/consts";
import ClustersSignup from "./clusters-signup/clusters-signup";
import { StyledCarouselSelectableProductCardsGridComponent } from "./carousel-selectable-product-cards-grid-component.scss";
import SelectableProductCard from "./selectable-product-card/selectable-product-card";
import PrevCarouselArrow from "./carousle-arrows/prev-carousel-arrow";
import NextCarouselArrow from "./carousle-arrows/next-carousel-arrow";
import DefaultProps from "./default-props";
import { useNumberOfSlides } from "segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/useNumberOfSlides";
const SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
const CarouselSelectableProductCardsGridComponent = ({ cards = [], selectableTags, autoPlay, isInView, defaultNumberOfCards = 3.5 })=>{
    const slider = useRef(null);
    const [selectedCardsIndexes, setSelectedCardsIndexes] = useState([]);
    const buttonContainer = useRef(null);
    const [wasClusterSelected, setWasClusterSelected] = useState(false);
    const isAutoPlay = useMemo(()=>isInView && !!autoPlay.enable, [
        isInView,
        autoPlay.enable
    ]);
    const slidesToShow = useNumberOfSlides(cards.length);
    const selectedTags = useMemo(()=>selectedCardsIndexes.map((index)=>cards[index].tag), [
        selectedCardsIndexes,
        cards
    ]);
    const selectedProducts = useMemo(()=>selectedCardsIndexes.map((index)=>cards[index].productType), [
        selectedCardsIndexes,
        cards
    ]);
    const onTagsClick = (cardIndex)=>{
        setSelectedCardsIndexes((prevSelectedIndexes)=>prevSelectedIndexes.includes(cardIndex) ? prevSelectedIndexes.filter((index)=>index !== cardIndex) : [
                ...prevSelectedIndexes,
                cardIndex
            ]);
        setTimeout(()=>setWasClusterSelected(true), SIGNUP_BUTTON_ANIMATION_START_TIME);
    };
    const onCardClick = (tag, productType, index)=>{
        var _buttonContainer_current;
        if (!selectableTags) return;
        onTagsClick(index);
        (_buttonContainer_current = buttonContainer.current) === null || _buttonContainer_current === void 0 ? void 0 : _buttonContainer_current.clickedTag(_object_spread({
            tagIndex: index
        }, tag), !selectedTags.includes(tag));
    };
    const itemRenderer = (card, index)=>/*#__PURE__*/ _jsx(SelectableProductCard, _object_spread({
            selectableTags: selectableTags,
            onClick: ()=>onCardClick(card.tag, card.productType, index)
        }, card));
    const carouselProps = {
        items: cards,
        autoplay: isAutoPlay,
        slidesToShow: slidesToShow || defaultNumberOfCards,
        autoplaySpeed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.autoplaySpeed,
        speed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.speed,
        itemRenderer,
        prevArrow: /*#__PURE__*/ _jsx(PrevCarouselArrow, {
            pause: ()=>{
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        }),
        nextArrow: /*#__PURE__*/ _jsx(NextCarouselArrow, {
            pause: ()=>{
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        })
    };
    return /*#__PURE__*/ _jsxs(StyledCarouselSelectableProductCardsGridComponent, {
        isAutoPlay: isAutoPlay,
        onMouseLeave: ()=>{
            var _slider_current;
            return isAutoPlay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.play());
        },
        className: "carousel-selectable-product-cards-grid-component",
        onAnimationEnd: ()=>setWasClusterSelected(false),
        children: [
            /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, CAROUSEL_PROPS, carouselProps), {
                ref: slider
            })),
            selectableTags && /*#__PURE__*/ _jsx(ClustersSignup, {
                selectedProducts: selectedProducts,
                clusters: selectedTags,
                wasClusterSelected: wasClusterSelected
            })
        ]
    });
};
CarouselSelectableProductCardsGridComponent.defaultProps = DefaultProps;
export default CarouselSelectableProductCardsGridComponent;
